module.exports = __webpack_public_path__ + "static/img/sybg.8aef446.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sybg.jpg
// module id = fGSe
// module chunks = 160